import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api-service';
import { Angulartics2Segment } from 'angulartics2';
import { RankingsAnonFormService } from './rankings-anon-form.service';

export interface UserTrackingProperties {
  userId?: string;
  clientId?: string;
  email?: string;
  pseudoUser?: boolean;
}

@Injectable()
export class TrackingService extends BaseApiService {
  private userProperties: UserTrackingProperties;
  private disabled: boolean = false;
  private isAnonymous: boolean = true;

  constructor(
    private segment: Angulartics2Segment,
    private _service: RankingsAnonFormService
  ) {
    super();
    this.disabled = this.getEnv() !== 'prod'; // disabled if not production
  }

  public identify(properties: UserTrackingProperties) {
    if (this.disabled) return;

    this.isAnonymous = false;
    this.segment.setUserProperties(properties);
    this.userProperties = properties;
  }

  public identifyAnonymous() {
    if (this.disabled) return;

    this.isAnonymous = true;
    this.userProperties = {};

    const submittedEmail = this._service.getSubmittedEmail();
    if (submittedEmail) {
      this.identify({ email: submittedEmail });
    }
  }

  public pageTrack(path?: string) {
    if (this.disabled || this.isAnonymous) {
      return;
    }
    this.segment.pageTrack(path);
  }

  public eventTrack(action: string, properties: any): void {
    if (this.disabled || this.isAnonymous) {
      return;
    }

    const { clientId, email, pseudoUser } = this.userProperties;
    if (clientId) {
      properties['clientid'] = clientId;
    }
    if (email) {
      properties['email'] = properties['email'] || email;
    }
    if (pseudoUser) {
      properties['pseudoUser'] = pseudoUser;
    }

    this.segment.eventTrack(action, properties);
  }

  public eventTrackAnonymous(action: string, properties: any): void {
    if (this.disabled) {
      return;
    }

    this.segment.eventTrack(action, properties);
  }
}
